// Shared types and functions for Advanced Search
// Used by CombinedSearchPro.tsx and useAdvancedSearchTabs.ts

export interface ClueWithLanguage {
  clue: string;
  language: number;
}

export interface CombinedResult {
  word: string;
  wordLength: number;
  clues: string[];
  allClues: ClueWithLanguage[];
  matchPercentage: number;
  language: number;
}

export type SortOption = "relevance" | "alphabetical";

export const MAX_LENGTH = 30;

/**
 * Calculate possible letters at each position from search results.
 * Used for constraint propagation between linked tabs.
 */
export function calculatePossibleLetters(results: CombinedResult[]): Map<number, Set<string>> {
  const possible = new Map<number, Set<string>>();
  
  results.forEach(result => {
    const word = result.word.toUpperCase();
    for (let i = 0; i < word.length; i++) {
      if (!possible.has(i)) {
        possible.set(i, new Set());
      }
      possible.get(i)!.add(word[i]);
    }
  });
  
  return possible;
}
